module.exports = __webpack_public_path__ + "img/menu.a731fb4e.svg";